import axios from 'axios';
import env from '../config/environments';

const api = axios.create({
    baseURL: env.pathApi,
})

export default api;